import {CommonModule} from '@angular/common';
import {Component, Input} from '@angular/core';

/**
 * Presentation-only section shell for Operational Readiness.
 * Parents supply title/copy and project status cards / warnings into the body.
 */
@Component({
    selector: 'app-operational-section-shell',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './operational-section-shell.component.html',
    styleUrl: './operational-section-shell.component.css',
})
export class OperationalSectionShellComponent {
    @Input() title = '';
    @Input() subtitle = '';
    @Input() summary = '';
    @Input() loading = false;
    @Input() errorMessage = '';
    @Input() emptyMessage = '';
}
